import * as React from "react";
import type { StyleProp, TextStyle } from "react-native";

import { Typography } from "@smartrent/ui";
import type { TextVariation } from "@smartrent/tokens";

const DEFAULT_VARIATION: TextVariation = "regular.body.medium";

interface AddressLineProps {
  isCustom?: boolean;
  variation?: TextVariation;
  style?: StyleProp<TextStyle>;
  children: React.ReactNode;
}

export function AddressLine({
  isCustom,
  variation = DEFAULT_VARIATION,
  style,
  children,
}: AddressLineProps): React.ReactElement {
  return (
    <Typography
      variation={variation}
      color={isCustom ? "warning" : undefined}
      style={style}
    >
      {children}
    </Typography>
  );
}
